import { createApi, createBaseQuery } from '@adv-frontend/modules-query';
import { apiV1Request } from '#shared/api/requests';
import {
    type OpenApiGetDashboardOrdersRequest,
    type OpenApiGetDashboardOrdersResponseSuccess,
} from '#shared/api/schema';

const apiDashboardOrders = createApi({
    name: 'entities/dashboard/api/orders',
    baseQuery: createBaseQuery(apiV1Request),
    endpoints: (builder) => {
        return {
            get: builder.query<OpenApiGetDashboardOrdersResponseSuccess, OpenApiGetDashboardOrdersRequest>({
                query: () => {
                    return {
                        url: '/dashboard/orders',
                        method: 'GET',
                    };
                },
            }),
        };
    },
});

export const useGetDashboardOrders = apiDashboardOrders.useGetQuery;
